import {
  BarChartOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  ContactsOutlined,
  CheckSquareOutlined,
  AccountBookOutlined,
  ApartmentOutlined,
  ToolOutlined,
  WalletOutlined,
  IdcardOutlined,
  DollarCircleOutlined,
  FileDoneOutlined,
  FundOutlined,
  LineChartOutlined,
  RiseOutlined,
  ShoppingOutlined,
  MessageOutlined,
  SolutionOutlined,
  MenuUnfoldOutlined,
  HistoryOutlined,
  SettingOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  BellOutlined,
  PieChartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AdminLayout } from "layouts/AdminLayout";
import React from "react";
import { NotFoundPage } from "views/404/NotFoundPage";
import { ConfigurationPage } from "views/Configuration/ConfigurationPage";
import { ConnectionErrorPage } from "views/ConnectionError/ConnectionErrorPage";
import LoginPage from "views/Login/LoginPage";
import { ProfilePage } from "views/Profile/ProfilePage";
import { CommissionPage } from "views/Commission/CommissionPage";
import { RevenuePage } from "views/Revenue/RevenuePage";
import { ExpensePage } from "views/Expense/ExpensePage";
import { ProfitPage } from "views/Profit/ProfitPage";
import { EmployeePage } from "views/Employee/EmployeePage";
import { AttendancePage } from "views/Attendance/AttendancePage";
import { TechnicalCommissionPage } from "views/TechnicalCommission/TechnicalCommissionPage";
import { DepartmentPage } from "views/Department/DepartmentPage";
import { CustomerPage } from "views/Customer/CustomerPage";
import { PartnerPage } from "views/Partner/PartnerPage";
import { CustomerReminderPage } from "views/CustomerReminder/CustomerReminderPage";
import { CustomerAnalyticsPage } from "views/CustomerAnalytics/CustomerAnalyticsPage";
import { OpportunityFormPage } from "views/Opportunity/OpportunityFormPage";
import { OpportunityPage } from "views/Opportunity/OpportunityPage";
import { QuotePage } from "views/Opportunity/QuotePage";
import { OrderPage } from "views/Order/OrderPage";
import { FeedbackPage } from "views/Feedback/FeedbackPage";
import { LeadPage } from "views/Lead/LeadPage";
import { LogPage } from "views/Log/LogPage";
import { RolePage } from "views/Role/RolePage";
import { StaffPage } from "views/Staff/StaffPage";
import { TodoPage } from "views/Todo/TodoPage";
import { WorkSchedulePage } from "views/WorkSchedule/WorkSchedulePage";
import { DebtPage } from "views/Debt/DebtPage";
import { SaleStatsPage } from "views/SaleStats/SaleStatsPage";

export interface AppRoute {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  name?: string;
  title?: string;
  children?: AppRoute[];
  icon?: React.ReactNode;
  breadcrumb?: string;
  isAccess?: boolean;
  hidden?: boolean;
  hideInMenu?: boolean; // vẫn truy cập/breadcrumb bình thường, chỉ không hiện trong menu
  group?: string; // gom các route cùng group thành 1 submenu (chỉ ảnh hưởng hiển thị menu)
  checkIsDev?: boolean;
  isPublic?: boolean; // luôn truy cập được, không cần permission
  description?: string;
}

export type Route = AppRoute;

export const adminRoutes: AppRoute[] = [
  {
    title: "Lead",
    icon: <SolutionOutlined />,
    name: "lead",
    element: <LeadPage title="Lead" />,
    path: "/lead",
    group: "Khách hàng",
  },
  {
    title: "Khách hàng",
    icon: <ContactsOutlined />,
    name: "customer",
    element: <CustomerPage title="Khách hàng" />,
    path: "/customer",
    group: "Khách hàng",
  },
  {
    title: "Nhắc tương tác",
    icon: <BellOutlined />,
    name: "customerReminder",
    element: <CustomerReminderPage title="Nhắc tương tác" />,
    path: "/customer-reminder",
    group: "Khách hàng",
  },
  {
    title: "Phân tích khách hàng",
    icon: <PieChartOutlined />,
    name: "customerAnalytics",
    element: <CustomerAnalyticsPage title="Phân tích khách hàng" />,
    path: "/customer-analytics",
    group: "Khách hàng",
  },
  {
    title: "Đối tác giới thiệu",
    icon: <UsergroupAddOutlined />,
    name: "partner",
    element: <PartnerPage title="Đối tác giới thiệu" />,
    path: "/partner",
    group: "Khách hàng",
  },
  {
    title: "Cơ hội",
    icon: <FundOutlined />,
    name: "opportunity",
    element: <OpportunityPage title="Cơ hội" />,
    path: "/opportunity",
  },
  {
    title: "Báo giá",
    icon: <FileDoneOutlined />,
    name: "quote",
    element: <QuotePage title="Báo giá" />,
    path: "/quote",
  },
  {
    title: "Đơn hàng",
    icon: <ShoppingOutlined />,
    name: "order",
    element: <OrderPage title="Đơn hàng" />,
    path: "/order",
  },
  {
    title: "Việc cần làm",
    icon: <CheckSquareOutlined />,
    name: "todo",
    element: <TodoPage title="Việc cần làm" />,
    path: "/todo",
    group: "Công việc",
  },
  {
    title: "Lịch công tác",
    icon: <CalendarOutlined />,
    name: "work-schedule",
    element: <WorkSchedulePage title="Lịch công tác" />,
    path: "/work-schedule",
    group: "Công việc",
  },
  {
    title: "Phản hồi",
    icon: <MessageOutlined />,
    name: "feedback",
    element: <FeedbackPage title="Phản hồi" />,
    path: "/feedback",
    group: "Công việc",
  },
  {
    title: "Hoa hồng",
    icon: <DollarCircleOutlined />,
    name: "commission",
    element: <CommissionPage title="Hoa hồng SALE" />,
    path: "/commission",
    group: "SALE",
  },
  {
    title: "Thống kê",
    icon: <BarChartOutlined />,
    name: "sale-stats",
    element: <SaleStatsPage title="Thống kê SALE" />,
    path: "/sale-stats",
    group: "SALE",
  },
  {
    title: "HH KT",
    icon: <ToolOutlined />,
    name: "commission-technical",
    element: <TechnicalCommissionPage title="Hoa hồng kỹ thuật" scope="technical" />,
    path: "/commission-technical",
    group: "HH KT",
  },
  {
    title: "HH Chương",
    icon: <WalletOutlined />,
    name: "commission-chuong",
    element: <TechnicalCommissionPage title="HH Chương" scope="chuong" />,
    path: "/commission-chuong",
    group: "HH KT",
  },
  {
    title: "HH Dung",
    icon: <WalletOutlined />,
    name: "commission-dung",
    element: <TechnicalCommissionPage title="HH Dung" scope="dung" />,
    path: "/commission-dung",
    group: "HH KT",
  },
  {
    title: "Doanh thu",
    icon: <LineChartOutlined />,
    name: "revenue",
    element: <RevenuePage title="Doanh thu" />,
    path: "/revenue",
    group: "Tài chính",
  },
  {
    title: "Chi phí",
    icon: <AccountBookOutlined />,
    name: "expense",
    element: <ExpensePage title="Chi phí" />,
    path: "/expense",
    group: "Tài chính",
  },
  {
    title: "Lợi nhuận",
    icon: <RiseOutlined />,
    name: "profit",
    element: <ProfitPage title="Lợi nhuận" />,
    path: "/profit",
    group: "Tài chính",
  },
  {
    title: "Công nợ",
    icon: <CreditCardOutlined />,
    name: "debt",
    element: <DebtPage title="Công nợ" />,
    path: "/debt",
    group: "Tài chính",
  },
  {
    title: "Nhân sự",
    icon: <IdcardOutlined />,
    name: "employee",
    element: <EmployeePage title="Nhân sự" />,
    path: "/employee",
    group: "Nhân sự",
  },
  {
    title: "Chấm công - Bảng lương",
    icon: <CalendarOutlined />,
    name: "attendance",
    element: <AttendancePage title="Chấm công - Bảng lương" />,
    path: "/attendance",
    group: "Nhân sự",
  },
  {
    title: "Phòng ban",
    icon: <ApartmentOutlined />,
    name: "department",
    element: <DepartmentPage title="Phòng ban" />,
    path: "/department",
    group: "Nhân sự",
  },
  {
    title: "Tạo cơ hội",
    name: "opportunity-create",
    element: <OpportunityFormPage />,
    path: "/opportunity/create",
    hidden: true,
  },
  {
    title: "Chi tiết cơ hội",
    name: "opportunity-detail",
    element: <OpportunityFormPage />,
    path: "/opportunity/:id",
    hidden: true,
  },
  {
    title: "Chi tiết báo giá",
    name: "quote-detail",
    element: <OpportunityFormPage />,
    path: "/quote/:id",
    hidden: true,
  },
  {
    title: "Nhân viên",
    icon: <TeamOutlined />,
    name: "staff",
    element: <StaffPage title="Nhân viên" />,
    path: "/staff",
    group: "Quản trị",
  },
  {
    title: "Vai trò",
    icon: <MenuUnfoldOutlined />,
    name: "role",
    element: <RolePage title="Vai trò" />,
    path: "/role",
    group: "Quản trị",
  },
  {
    title: "Log",
    icon: <HistoryOutlined />,
    name: "log",
    element: <LogPage title="Log" />,
    path: "/log",
    group: "Quản trị",
  },
  {
    title: "Cấu hình",
    icon: <SettingOutlined />,
    name: "configuration",
    element: <ConfigurationPage title="Cấu hình" />,
    path: "/configuration",
    group: "Quản trị",
  },
  {
    title: "Cá nhân",
    icon: <UserOutlined />,
    path: "/profile",
    name: "permission",
    element: <ProfilePage title="Cá nhân" />,
    isPublic: true,
    hideInMenu: true,
  },
];

const routes: AppRoute[] = [
  {
    path: "/",
    element: <AdminLayout />,
    children: adminRoutes,
  },
  {
    path: "/login",
    element: <LoginPage title="Đăng nhập" />,
  },
  {
    path: "/connection-error",
    element: <ConnectionErrorPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export { routes };
